/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		// Idempotent : peut être appelé par connectedCallback ET explicitement après
		// l'injection du drawer (Safari ne déclenche pas toujours connectedCallback
		// pour un élément réinjecté via innerHTML).
		if (this.isLoading || this.classList.contains('product-recommendations--loaded')) return;
		if (!this.dataset.url) return;
		this.isLoading = true;

		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			})
			.finally(() => {
				this.isLoading = false;
			});
	}
	connectedCallback() {
		this.parent = this.parent || this.closest('.product-recommendations--parent');
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
